export default "__VITE_ASSET__B9p16iuM__"